// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const getDashBoardData = createAction('settings/getDashBoardData');
